import SAJM_GLOBALS from "../constants";
import { order_result, organization } from "src/models/HelloAsso/@types/HelloAsso";
//import GlobalUser from "../models/User";

export class HelloAssoController{

    async getToken(){

        const formData = new URLSearchParams();
        formData.append('grant_type', 'client_credentials');
        formData.append('client_id', SAJM_GLOBALS.HA_CLIENTID);
        formData.append('client_secret', SAJM_GLOBALS.HA_CLIENTSECRET);

        try {
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: formData.toString(),
                json:true
            };

            let url = SAJM_GLOBALS.HA_API_HOST+SAJM_GLOBALS.HA_API_ROUTE_TOKEN;

            const response = await fetch(url, requestOptions);
            
            if (!response.ok) {
                //debugger;
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("HelloAssoController.getToken:"+error);
            return undefined;
        }

    }

    /**
     * Refresh token
     * @param {string} refresh_token Token to refresh
     * @returns {token}
     */
    async refreshToken(refresh_token:string){

        const formData = new URLSearchParams();
        formData.append('grant_type', 'refresh_token');
        formData.append('refresh_token', refresh_token);
        try {
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: formData.toString(),
                json:true
            };

            let url = SAJM_GLOBALS.HA_API_HOST+SAJM_GLOBALS.HA_API_ROUTE_TOKEN;

            const response = await fetch(url, requestOptions);
            
            if (!response.ok) {
                //debugger;
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("HelloAssoController.refreshToken:"+error);
            return undefined;
        }

    }

    /**
     * Retrieve Hello asso organization
     * @param api_key API Key
     * @returns organization 
     */
    async getOrganization(api_key:string):Promise<organization|null>{

        try {

            const requestOptions = {
                method: 'GET',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': 'Bearer '+api_key }
            };

            let url = SAJM_GLOBALS.HA_API_HOST+SAJM_GLOBALS.HA_API_ROUTE_MY_ORGANIZATIONS;

            const response = await fetch(url, requestOptions);
            
            if (!response.ok) {
                //debugger;
                throw Error(response.statusText);
            }
            
            let organization = await response.json()
            if(Array.isArray(organization)){
                organization=organization[0];
            }
            return organization;

        }
        catch (error) {
            console.log("HelloAssoController.getOrganization:"+error);
            return null
        }

    }



    /**
     * Get list of orders
     * @param organizationSlug Hello Asso Slug
     * @param api_key API Key
     * @returns type order_result
     */
    async getOrders(organizationSlug:string, api_key:string):Promise<order_result|null>{
        try {

            const requestOptions = {
                method: 'GET',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': 'Bearer '+api_key }
            };

            let url = SAJM_GLOBALS.HA_API_HOST+SAJM_GLOBALS.HA_API_ROUTE_ORGANIZATIONS+"/"+organizationSlug+"/items?tierTypes=Donation&withCount=true";

            const response = await fetch(url, requestOptions);
            
            if (!response.ok) {
                //debugger;
                throw Error(response.statusText);
            }
            
            let orders = await response.json()
            
            return orders;

        }
        catch (error) {
            console.log("HelloAssoController.getOrders:"+error);
            return null
        }
    }







}
export default HelloAssoController;